// Amount of days after campaign end that prize post can use to be sent
export const EXTRA_DAYS_FOR_PRIZE_POST = 15;

// Prize statuses
export const DRAFT = 'draft';
export const LIVE = 'live';
export const FINISHED = 'finished';
export const PICKED = 'picked';

export const SCHEDULED = 'scheduled';

// Post show error timer
export const ERROR_TIMER = 3000;

// Post message review form labels
export const MESSAGE = 'message';
export const CHOOSE = 'choose';
export const REMINDER = 'reminder';
export const REVIEW = 'review';
export const REVIEW_WITHOUT_NOTIFICATION = 'no-notification-review';
export const EMAIL = 'Email';
export const SMS = 'Sms';

// Campaign step ids
export const DATE = 'date';
export const BANNER = 'banner';
export const POSTS = 'posts';
export const PRIZES = 'prizes';
export const APPROVAL = 'approval';
export const PREVIEW = 'preview';
export const EDIT = 'edit';

// Post actions
export const CREATE = 'create';
